export default __webpack_public_path__ + "static/media/1.529cfac6.png";